import React from 'react';
import { AvailEntryForm, cellLabel } from './availTimeFields';

const S = {
  card: { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 16, marginBottom: 16 },
  btn: (bg = '#7b4f2f') => ({ padding: '8px 14px', border: 'none', borderRadius: 8, background: bg, color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }),
  btnGhost: { padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', color: '#374151', fontWeight: 600, fontSize: 13, cursor: 'pointer' },
  h: { fontSize: 15, fontWeight: 800, margin: '0 0 10px', color: '#1f2937' },
};

export default function MonthCalendarPanel({
  month,
  overview,
  windowForm,
  setWindowForm,
  onSaveWindow,
  onToggleLock,
  onDownloadAvail,
  availEdit,
  setAvailEdit,
  onPatchAvail,
}) {
  return (
    <div>
      {overview && (
        <div style={S.card}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 12 }}>
            <h3 style={{ ...S.h, margin: 0 }}>可上總覽 · {month}</h3>
            <span style={{ fontWeight: 700, color: overview.missingPeople?.length ? '#b91c1c' : '#047857' }}>
              已送 {overview.submittedCount}/{overview.requiredCount}
            </span>
            <button type="button" style={S.btn(overview.lock?.isLocked ? '#b91c1c' : '#047857')} onClick={onToggleLock}>
              {overview.lock?.isLocked ? '解除鎖定' : '鎖定填寫'}
            </button>
            <button type="button" style={S.btnGhost} onClick={onDownloadAvail}>下載可上 JSON</button>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 12, fontSize: 13 }}>
            <span style={{ fontWeight: 700 }}>填寫區間</span>
            <input type="datetime-local" value={windowForm.openAt} onChange={(e) => setWindowForm((s) => ({ ...s, openAt: e.target.value }))} />
            <span>至</span>
            <input type="datetime-local" value={windowForm.closeAt} onChange={(e) => setWindowForm((s) => ({ ...s, closeAt: e.target.value }))} />
            <button type="button" style={S.btnGhost} onClick={onSaveWindow}>儲存區間</button>
          </div>
          {overview.missingPeople?.length > 0 && (
            <div style={{ marginBottom: 10, color: '#b91c1c', fontSize: 13 }}>缺：{overview.missingPeople.join('、')}</div>
          )}
          <div style={{ overflowX: 'auto' }}>
            <table style={{ borderCollapse: 'collapse', fontSize: 12, minWidth: 800 }}>
              <thead>
                <tr>
                  <th style={{ position: 'sticky', left: 0, background: '#fff', padding: 4, border: '1px solid #e5e7eb' }}>姓名</th>
                  {(overview.dayHeaders || []).map((h) => (
                    <th
                      key={h.day}
                      style={{
                        padding: 4,
                        border: '1px solid #e5e7eb',
                        background: h.weekend ? '#CFE2F3' : '#f8fafc',
                        color: h.redDay ? '#dc2626' : undefined,
                        fontWeight: h.redDay ? 800 : undefined,
                      }}
                    >
                      {h.day}
                      <div style={{ fontWeight: 400 }}>{h.wd}</div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(overview.people || []).map((p) => (
                  <tr key={p.staffPhone}>
                    <td style={{ position: 'sticky', left: 0, background: '#fff', padding: 4, border: '1px solid #e5e7eb', fontWeight: 700 }}>
                      {p.person}
                    </td>
                    {(p.cells || []).map((c) => {
                      const shown = cellLabel({ base: c.base, overrides: c.overrides }) || c.text || '—';
                      const isOff = c.base === '休' && !(c.overrides && c.overrides.length);
                      const isOk = (c.base === '可' && !(c.overrides && c.overrides.length)) || c.hasOverrides;
                      return (
                        <td
                          key={c.day}
                          role="button"
                          tabIndex={0}
                          onClick={() => setAvailEdit({
                            person: p,
                            day: c.day,
                            entry: { day: c.day, base: c.base || null, overrides: c.overrides || [], note: c.note || '' },
                          })}
                          style={{
                            padding: 3,
                            border: '1px solid #e5e7eb',
                            textAlign: 'center',
                            cursor: 'pointer',
                            background: isOk ? '#DCEAE5' : isOff ? '#EFE6D0' : '#fff',
                            color: isOk ? '#3E7C6E' : isOff ? '#9A7F3F' : '#374151',
                            fontWeight: 600,
                          }}
                        >
                          {shown}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {availEdit && (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 9000, background: 'rgba(0,0,0,.35)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
          }}
          onClick={() => setAvailEdit(null)}
        >
          <div
            style={{ background: '#fff', borderRadius: 12, padding: 16, minWidth: 280, maxWidth: 420, width: '100%' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ fontWeight: 800, marginBottom: 10 }}>{availEdit.person.person} · {availEdit.day}日</div>
            <AvailEntryForm
              day={availEdit.day}
              initial={availEdit.entry}
              onCommit={(entry) => onPatchAvail(availEdit.person, availEdit.day, entry)}
              onCancel={() => setAvailEdit(null)}
              allowClear
            />
          </div>
        </div>
      )}
    </div>
  );
}
